<template>
  <div class="left-line">
    <div id="echart"></div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "hiddenDangerStatistic",
  props: {
    echartsData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      myChart: {}
    };
  },
  created() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  mounted() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.resize();
    // };
  },
  watch: {
    echartsData: function(newVal) {
      this.loadEchart();
    }
  },
  methods: {
    loadEchart() {
      let colors = ["#6AE091", "#7D8CFF"];
      this.myChart = Echarts.init(document.getElementById("echart"));
      let option = {
        title: {
          // text: "折线图堆叠",
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          show: false,
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          bottom: "bottom",
          textStyle: {
            color: "#B4BBE0"
          },
          data: ["上报隐患数", "已处理隐患数"]
        },
        grid: {
          top: 20,
          left: 30,
          right: 30,
          bottom: 10,
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "category",
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 1,
            formatter: function(params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var stringResult = params.split('-');
              var newString = stringResult[0] + '年' + stringResult[1] + '月'
              var paramsNameNumber = newString.length; // 实际标签的个数
              var provideNumber = 5; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 计算行数，向上取整 //判断是否需要换行
              if (paramsNameNumber > provideNumber) {
                //循环得到每行的显示内容，p代表行
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = newString.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = newString.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = newString;
              }
              return newParamsName;
            }
          },
          // axisLabel: {
          //   show: true,
          //   interval:0,
          //   // rotate:30,
          //   textStyle: {
          //     color: "#B4BBE0",
          //     fontSize: "14",
          //   },

          // },
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#D0D8FF"
            }
          },
          data: []
        },
        yAxis: {
          type: "value",
          minInterval: 1, //只显示整数
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "14"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#B4BBE0",
              type: "solid",
              opacity: 0.5
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        // dataZoom: [
        //   {
        //     show: false,
        //     textStyle: {
        //       color: "rgba(255,255,255,0)"
        //     },
        //     type: "inside",
        //     xAxisIndex: [0],
        //     left: "5%",
        //     bottom: 0,
        //     start: 0,
        //     end: 100 //初始化滚动条
        //   }
        // ],
        series: [
          {
            name: "上报隐患数",
            type: "line",
            stack: "总量",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            }
          },
          {
            name: "已处理隐患数",
            type: "line",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            }
          }
        ],
        color: colors
      };
      // option.dataZoom[0].end = (6 / this.echartsData.length) * 100;
      option.series[0].data = this.echartsData.map((item) => {
        // console.log(item);
        return {
          // name:item.name || '',
          value: item.totalNum || 0
        };
      });
      option.series[1].data = this.echartsData.map((item) => {
        return {
          // name:item.name || '',
          value: item.checkedNum || 0
        };
      });
      option.xAxis.data = this.echartsData.map((item) => {
        return item.ym || "";
      });
      // console.log(option.xAxis.data)
      // console.log(option.legend.data)

      this.myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.left-line {
  padding-top: 10px;
  #echart {
    // width: 1000px;
    height: 210px;
  }
}
</style>
